import React, { useContext } from "react"
import { faHandsHeart } from "@fortawesome/pro-light-svg-icons"

import SmartLink from "../../../layout/SmartLink/SmartLink"
import SingleGeoContext from "../../../../contexts/single_geo"
import {
  generateGeoPathData,
  geoAreaLocationProviderDirectoryPath,
} from "../../../../utils/paths"

import ListItemWithIcon from "../../../ListItemWithIcon/ListItemWithIcon"
import { BodyText, InlineText, Strong } from "../../../Typography/Typography"
import LineBreak from "../../../LineBreak/LineBreak"

const AgnosticLink = () => {
  const {
    geographicScale,
    locationName,
    totalHomeCareCount,
    totalCareHomeCount,
    districtType,
  } = useContext(SingleGeoContext)

  const careTypePath = geoAreaLocationProviderDirectoryPath(
    generateGeoPathData(geographicScale, locationName, undefined, districtType),
  )

  const additionalAgnosticText =
    totalCareHomeCount && totalHomeCareCount
      ? " This includes all care homes and home care agencies."
      : ""

  const totalProviders = totalCareHomeCount + totalHomeCareCount

  const pluraliseCareProvider =
    totalProviders === 1
      ? `is ${totalProviders} care provider`
      : `are ${totalProviders} care providers`

  const agnosticCopy = (
    <BodyText>
      There {pluraliseCareProvider} in {locationName}.{additionalAgnosticText}
    </BodyText>
  )

  return (
    <ListItemWithIcon icon={faHandsHeart} iconSize="2x" showSeparator>
      <BodyText bold>Compare all care providers</BodyText>
      {agnosticCopy}
      <SmartLink
        to={careTypePath}
        chevron
        clickEvent={{
          name:
            "SEO - Filtered Directory - Care Type Changed - Care Agnostic Clicked",
        }}
      >
        <InlineText brand>
          See <Strong brand>all elderly care</Strong> in{" "}
          <LineBreak onDesktopOnly />
          {locationName}
        </InlineText>
      </SmartLink>
    </ListItemWithIcon>
  )
}

export default AgnosticLink
